import { useListItem } from '@floating-ui/react'

export function useFloatingListItem(props) {
  return useListItem(props)
}
